import type { RegistrationStatus } from '../data/registrationStatus'
import styles from './EventCard.module.css'

export function StatusBadge({ status }: { status: RegistrationStatus }) {
  return (
    <div className={styles.statusRow} style={{ color: status.textColor }}>
      <span className={styles.statusDot} style={{ background: status.dotColor }} />
      {status.label}
      {status.unpaid ? <span className={styles.statusUnpaid}> · Unpaid</span> : null}
    </div>
  )
}

const CTA_CLASS: Record<RegistrationStatus['ctaKind'], string> = {
  primary: styles.ctaPrimary,
  secondary: styles.ctaSecondary,
  dark: styles.ctaDark,
  danger: styles.ctaDanger,
}

/** `canSignUp` gates the "Sign up" CTA specifically - a racer who isn't logged in can't actually
 *  sign up (displayEvent.cfm would just bounce them to login), so the button is dropped entirely
 *  rather than shown and failing later. "My entry"/"Pay" are unaffected - those don't require
 *  being logged in as a racer.
 *
 *  "Details" and "Remind me" are dropped entirely (removed per request, 2026-10-10) - a 'full'/
 *  'closed' event now shows its status label with no CTA, same for 'soon'.
 *
 *  TODO(future): "Remind me" is meant to come back once there's a real reminder feature behind
 *  it - emails the racer 30 minutes before the event's registration window opens
 *  (openPaymentDT, see registrationStatus.ts's 'soon' case). Not built yet; this just removes
 *  the dead button rather than ship it pointing at nothing. */
export function CtaButton({
  status,
  href,
  canSignUp = true,
}: {
  status: RegistrationStatus
  href: string
  canSignUp?: boolean
}) {
  if (status.cta === 'Sign up' && !canSignUp) return null
  if (status.cta === 'Details' || status.cta === 'Remind me') return null

  return (
    <a href={status.ctaHref ?? href} className={`${styles.cta} ${CTA_CLASS[status.ctaKind]}`}>
      {status.cta}
    </a>
  )
}
